import { BooleanInput } from 'react-admin'

/**
 * A yes/no input over a stored string (equipment values are text: 'true' /
 * 'false'). react-admin 5's BooleanInput applies format/parse itself.
 *
 * This used to force `checked` from the whole form's values, looked up by the
 * row-relative source — which never matched inside an equipment row, so the
 * switch was pinned to "off" and could not be switched on.
 */
const FormattedBooleanInput = ({ format, parse, source, ...props }) => (
  <BooleanInput format={format} parse={parse} source={source} {...props} />
)

export default FormattedBooleanInput
